// avstemming-payables-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avdp.assess.notAssessed': 'Ikke vurdert',
  'avdp.assess.noAction': 'OK – ingen tiltak',
  'avdp.assess.matchPayment': 'Skal matches mot betaling',
  'avdp.assess.wrongPosting': 'Feil bokføring — skal rettes',
  'avdp.assess.missingPosting': 'Manglende bokføring',
  'avdp.assess.duplicate': 'Duplikat',
  'avdp.assess.creditNote': 'Gjøres opp mot kreditnota',
  'avdp.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avdp.assess.awaitingClient': 'Avventer klienten',
  'avdp.assess.nextPeriod': 'Følges opp neste periode',
  'avdp.quick.needsAssessment': 'Krever vurdering',
  'avdp.quick.allOpen': 'Alle åpne',
  'avdp.quick.overdue': 'Forfalt',
  'avdp.quick.over90': 'Over 90 dager',
  'avdp.quick.negative': 'Negative saldoer',
  'avdp.quick.duplicates': 'Mulige duplikater',
  'avdp.quick.partlyPaid': 'Delbetalte',
  'avdp.quick.foreign': 'Valutaposter',
  'avdp.quick.missingDoc': 'Mangler bilag',
  'avdp.quick.paidAfter': 'Betalt etter periodedato',
  'avdp.quick.assessed': 'Ferdig vurdert',
  'avdp.days.notRelevant': 'Ikke relevant',
  'avdp.days.notDue': 'Ikke forfalt',
  'avdp.days.overdue': 'Forfalt med {days} dager',
  'avdp.flags.none': 'Ingen',
  'avdp.flags.more': '+{count} flere',
  'avdp.nav.overview': 'Oversikt',
  'avdp.nav.openItems': 'Åpne poster',
  'avdp.nav.suppliers': 'Leverandører',
  'avdp.nav.controls': 'Kontroller',
  'avdp.nav.conclusion': 'Konklusjon',
  'avdp.nav.blocked': 'Blokkert',
  'avdp.nav.ready': 'Klar',
  'avdp.toast.noAccount': 'Området har ingen avstemmingskonto i denne perioden.',
  'avdp.area.payables': 'Leverandørgjeld',
  'avdp.ledger.title': 'Leverandørreskontro og åpne poster',
  'avdp.filter.reset': 'Nullstill filtre',
  'avdp.filter.supplier': 'Leverandør: {name}',
  'avdp.filter.showAllSuppliers': 'Vis alle leverandører',
  'avdp.filter.controlAccount': 'Kontrollkonto: {account}',
  'avdp.filter.showAllAccounts': 'Vis alle kontrollkontoer',
  'avdp.filter.ageGroup': 'Aldersgruppe: {label}',
  'avdp.filter.showAllAges': 'Vis alle aldersgrupper',
  'avdp.col.supplier': 'Leverandør',
  'avdp.col.docNo': 'Dok.nr',
  'avdp.col.type': 'Type',
  'avdp.col.invoiceDate': 'Fakturadato',
  'avdp.col.due': 'Forfall',
  'avdp.col.original': 'Opprinnelig',
  'avdp.col.openAmount': 'Åpent beløp',
  'avdp.col.currency': 'Valuta',
  'avdp.col.daysOverdue': 'Dager forfalt',
  'avdp.col.flag': 'Varsel',
  'avdp.col.assessment': 'Vurdering',
  'avdp.row.viewAssessment': 'Se vurdering',
  'avdp.row.assess': 'Vurder',
  'avdp.ledger.noMatch': 'Ingen leverandørposter passer med filtrene.',
  'avdp.ledger.noOpen': 'Ingen åpne leverandørposter i denne perioden. Har klienten ingen ubetalte leverandørfakturaer, er det ingen reskontro å avstemme.',
  'avdp.header.controlAccount': 'Kontrollkonto {accounts}',
  'avdp.header.responsible': 'Ansvarlig {name}',
  'avdp.header.title': '{area} – hovedbok mot reskontro',
  'avdp.header.noControlAccount': 'Ingen kontrollkonto i området',
  'avdp.header.matches': 'Hovedbok og reskontro stemmer',
  'avdp.header.differs': 'Hovedbok og reskontro spriker',
  'avdp.header.noSubledger': 'Ingen kontrollkonto med reskontro',
  'avdp.header.needsAssessment': '{count} reskontroposter krever vurdering før avstemmingen kan sendes til kontroll.',
  'avdp.header.allAssessed': 'Ingen reskontroposter står igjen til vurdering.',
  'avdp.balance.title': 'Automatisk saldoavstemming',
  'avdp.balance.computedAt': 'Reskontroen er regnet per {date}',
  'avdp.balance.booked': 'Bokført saldo, kontrollkonto med reskontro',
  'avdp.balance.ledgerAt': 'Leverandørreskontro per {date}',
  'avdp.balance.difference': 'Differanse',
  'avdp.balance.noSubledger': 'Ingen av områdets kontoer er leverandørgjeldskontoen appen fører kjøp mot ({account}). Da finnes ingen reskontro å sammenlikne saldoen med, og differansen må forklares på kontoen selv.',
  'avdp.balance.mismatch': 'Kontrollkontoen stemmer ikke med reskontroen. Differansen må forklares før området kan avstemmes — se direkteføringene lenger ned.',
  'avdp.balance.opening': 'Saldo forrige periode',
  'avdp.balance.change': 'Endring i perioden',
  'avdp.balance.openInvoices': 'Åpne fakturaer',
  'avdp.balance.overdueAmount': 'Forfalt beløp',
  'avdp.balance.totalItems': 'Poster totalt i kontrollen',
  'avdp.balance.suppliersWithBalance': 'Leverandører med saldo',
  'avdp.accounts.title': 'Kontrollkontoer',
  'avdp.accounts.empty': 'Ingen balansekontoer er knyttet til leverandørgjeld i denne perioden. Uten en kontrollkonto finnes det ingen bokført saldo å sammenlikne reskontroen med.',
  'avdp.accounts.colAccount': 'Kontrollkonto',
  'avdp.accounts.colBooked': 'Bokført saldo',
  'avdp.accounts.colSubledger': 'Reskontrosaldo',
  'avdp.accounts.colDifference': 'Differanse',
  'avdp.accounts.colStatus': 'Status',
  'avdp.accounts.noSubledger': 'Ingen reskontro',
  'avdp.accounts.deviation': 'Avvik',
  'avdp.accounts.matches': 'Stemmer',
  'avdp.accounts.open': 'Åpne konto',
  'avdp.card.ledgerVsSubledger': 'Hovedbok mot reskontro',
  'avdp.card.ledgerVsSubledgerHint': 'Bokført saldo sammenliknet med summen av de åpne postene per periodeslutt.',
  'avdp.card.old': 'Gamle poster over 90 dager',
  'avdp.card.oldHint': 'Åpne poster forfalt mer enn 90 dager.',
  'avdp.card.negative': 'Negative leverandørsaldoer',
  'avdp.card.negativeHint': 'Fakturaer det er betalt mer på enn de lød på. Leverandøren skylder foretaket.',
  'avdp.card.duplicates': 'Mulige duplikater',
  'avdp.card.affected': '{count} berørte poster',
  'avdp.card.duplicatesHint': 'Samme leverandør, samme fakturadato og samme beløp.',
  'avdp.card.paymentsNoInvoice': 'Betalinger uten faktura',
  'avdp.card.paymentsNoInvoiceHint': 'Debetlinjer på kontrollkontoen uten en leverandørfaktura bak. Se direkteføringene lenger ned.',
  'avdp.card.partlyPaid': 'Delbetalt, men fortsatt åpen',
  'avdp.card.partlyPaidHint': 'Poster med registrert betaling som likevel står åpne.',
  'avdp.card.missingDoc': 'Manglende bilag',
  'avdp.card.missingDocHint': 'Åpne poster uten lagret bilag.',
  'avdp.card.overdue30': 'Forfalte poster over 30 dager',
  'avdp.card.overdue30Hint': 'Åpne poster forfalt mellom 31 og 90 dager.',
  'avdp.card.foreign': 'Valutaposter til kontroll',
  'avdp.card.foreignHint': 'Åpne fakturaer i annen valuta enn NOK. Kursen på balansedagen må kontrolleres.',
  'avdp.card.paidAfter': 'Betalt etter periodedato',
  'avdp.card.paidAfterHint': 'Åpne poster per periodedato som er betalt etterpå — normalt positiv dokumentasjon.',
  'avdp.card.direct': 'Direkteført på kontrollkonto',
  'avdp.card.directHint': 'Hovedbokslinjer på kontrollkontoene som ikke kommer fra en leverandørfaktura eller en betaling.',
  'avdp.card.title': 'Kontrollkort',
  'avdp.card.checksRun': 'Automatiske kontroller kjørt: {count} av {total}',
  'avdp.card.findings': 'Kontroller med funn: {count}',
  'avdp.card.manual': 'Poster som krever manuell vurdering: {count}',
  'avdp.card.hide': 'Skjul',
  'avdp.card.showAll': 'Vis alle automatiske kontroller',
  'avdp.card.activeFilter': 'Aktivt filter: {label}',
  'avdp.card.itemsCount': '{count} poster',
  'avdp.card.removeFilter': 'Fjern filter',
  'avdp.aging.title': 'Aldersfordeling (dager forfalt)',
  'avdp.aging.empty': 'Ingen åpne leverandørposter per periodeslutt — ingenting å fordele på alder.',
  'avdp.aging.note': 'Regnet fra forfallsdatoen, ikke fra fakturadatoen.',
  'avdp.aging.colAge': 'Alder',
  'avdp.aging.colCount': 'Antall poster',
  'avdp.aging.colAmount': 'Åpent beløp',
  'avdp.aging.colShare': 'Andel',
  'avdp.aging.needsAssessment': 'Krever vurdering',
  'avdp.aging.total': 'Sum åpne poster',
  'avdp.suppliers.emptyTitle': 'Leverandører med åpen saldo',
  'avdp.suppliers.empty': 'Ingen leverandører har åpen saldo per periodeslutt. Konsentrasjonen måles av de åpne postene, så uten dem er det ingen fordeling å vurdere.',
  'avdp.suppliers.title': 'Leverandører med åpne poster',
  'avdp.suppliers.topFive': 'De fem største utgjør {share} % av saldoen',
  'avdp.suppliers.colSupplier': 'Leverandør',
  'avdp.suppliers.colItems': 'Åpne poster',
  'avdp.suppliers.colAmount': 'Åpent beløp',
  'avdp.suppliers.colOverdue': 'Herav forfalt',
  'avdp.suppliers.colOldest': 'Eldste post',
  'avdp.suppliers.colShare': 'Andel',
  'avdp.suppliers.negative': 'Negativ saldo',
  'avdp.suppliers.days': '{days} dager',
  'avdp.direct.title': 'Direkteføringer på kontrollkontoen',
  'avdp.direct.empty': 'Ingen hovedbokslinjer på kontrollkontoene kommer fra noe annet enn en faktura eller en betaling. Kontrollen er kjørt — den fant ingenting.',
  'avdp.direct.note': 'Posteringer i perioden som ikke kommer fra en leverandørfaktura eller en betaling av en. En debetlinje uten faktura bak er en betaling ingen faktura svarer for.',
  'avdp.direct.colDate': 'Dato',
  'avdp.direct.colVoucher': 'Bilag',
  'avdp.direct.colText': 'Tekst',
  'avdp.direct.colAccount': 'Konto',
  'avdp.direct.colType': 'Type',
  'avdp.direct.colAmount': 'Beløp',
  'avdp.direct.paymentNoInvoice': 'Betaling uten faktura',
  'avdp.direct.debtNoInvoice': 'Gjeld uten faktura',
  'avdp.checks.title': 'Automatiske kontroller',
  'avdp.checks.note': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avdp.checks.colCheck': 'Kontroll',
  'avdp.checks.colRun': 'Kjøring',
  'avdp.checks.colResult': 'Resultat',
  'avdp.checks.run': 'Kjørt',
  'avdp.checks.findingsCount': '{count} funn',
  'avdp.checks.none': 'Ingen funn',
  'avdp.derived.old': 'Alle vesentlige gamle poster er vurdert',
  'avdp.derived.negative': 'Negative leverandørsaldoer er forklart',
  'avdp.derived.duplicate': 'Mulige duplikater er vurdert',
  'avdp.derived.partlyPaid': 'Delbetalte poster er undersøkt',
  'avdp.derived.foreign': 'Valutaposter er kontrollert',
  'avdp.derived.missingDoc': 'Poster uten bilag er behandlet',
  'avdp.blocker.one': '{count} reskontropost krever vurdering',
  'avdp.blocker.many': '{count} reskontroposter krever vurdering',
  'avdp.blocker.oneCritical': '{count} reskontropost krever vurdering, hvorav {critical} kritiske',
  'avdp.blocker.manyCritical': '{count} reskontroposter krever vurdering, hvorav {critical} kritiske',
  'avdp.blocker.diff': '{amount} av differansen mot reskontroen er uforklart',
  'avdp.blocker.pointOne': '{count} kontrollpunkt gjenstår',
  'avdp.blocker.pointMany': '{count} kontrollpunkter gjenstår',
  'avdp.check.title': 'Faglig sjekkliste',
  'avdp.check.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avdp.check.noPoints': 'Ingen kontrollpunkter er definert for leverandørgjeld i denne perioden.',
  'avdp.check.scope': 'Punktene gjelder hele området. En avkryssing lagres på alle kontrollkontoene i perioden.',
  'avdp.check.groupItems': 'Poster som krever behandling',
  'avdp.check.groupAssessments': 'Overordnede faglige vurderinger',
  'avdp.check.groupReady': 'Klarstilling',
  'avdp.check.count': '{done} av {total}',
  'avdp.check.processed': '{done} av {total} behandlet',
  'avdp.check.notApplicable': 'Ikke aktuelt denne perioden',
  'avdp.check.followsAssessments': 'Følger av vurderingene',
  'avdp.check.performedBy': 'Utføres av {name}',
  'avdp.check.completed': '{done} av {total} kontrollpunkter fullført',
  'avdp.concl.title': 'Konklusjon og godkjenning',
  'avdp.concl.placeholder': 'Hva viser gjennomgangen av leverandørgjelden for denne perioden?',
  'avdp.concl.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avdp.concl.remainingRisk': 'Gjenstående risiko',
  'avdp.concl.noRisk': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'avdp.concl.followUp': 'Oppfølging neste periode',
  'avdp.concl.noFollowUp': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avdp.concl.followed': 'Følges opp',
  'avdp.concl.measure': 'Tiltak: {text}',
  'avdp.concl.noMeasure': 'Ingen tiltak notert',
  'avdp.concl.deadline': 'Frist {date}',
  'avdp.concl.openAssessment': 'Åpne vurdering',
  'avdp.concl.send': 'Send området til kontroll',
  'avdp.concl.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avdp.concl.manyLeft': '{count} ting står igjen før området kan sendes.',
  'avdp.drawer.reasonOverdue': 'Posten er {days} dager forfalt',
  'avdp.drawer.reasonDuplicate': 'Mulig duplikat av {ids}',
  'avdp.drawer.reasonOverpaid': 'Betalt {paid} mot et bilag på {gross}',
  'avdp.drawer.reasonPartlyPaid': 'Delbetalt med {paid} i perioden',
  'avdp.drawer.reasonPaidAfter': 'Betalt {amount}, etter periodedato',
  'avdp.drawer.reasonPaidAfterOn': 'Betalt {amount} den {date}, etter periodedato',
  'avdp.drawer.reasonCurrencyRate': 'Ført i {currency} til kurs {rate}',
  'avdp.drawer.reasonCurrencyNoRate': 'Ført i {currency} uten lagret kurs',
  'avdp.drawer.reasonNoDoc': 'Ingen bilag er lagret på kjøpet',
  'avdp.drawer.unknownOrgNo': 'Ukjent org.nr',
  'avdp.drawer.close': 'Lukk',
  'avdp.drawer.invoiceDate': 'Fakturadato',
  'avdp.drawer.dueDate': 'Forfallsdato',
  'avdp.drawer.daysOverdue': 'Dager forfalt',
  'avdp.drawer.originalAmount': 'Opprinnelig beløp',
  'avdp.drawer.openAtEnd': 'Åpent per periodeslutt',
  'avdp.drawer.paidInPeriod': 'Betalt i perioden',
  'avdp.drawer.paidAfterDate': 'Betalt etter periodedato',
  'avdp.drawer.currencyRate': 'Valuta / kurs',
  'avdp.drawer.currency': 'Valuta',
  'avdp.drawer.controlAccount': 'Kontrollkonto',
  'avdp.drawer.voucher': 'Bilag',
  'avdp.drawer.stored': 'Lagret',
  'avdp.drawer.missing': 'Mangler',
  'avdp.drawer.assessment': 'Vurdering',
  'avdp.drawer.justification': 'Begrunnelse',
  'avdp.drawer.justificationRequired': 'Begrunnelse (påkrevd)',
  'avdp.drawer.justificationPlaceholder': 'Hva viser gjennomgangen av denne posten?',
  'avdp.drawer.measure': 'Tiltak',
  'avdp.drawer.measurePlaceholder': 'F.eks. Be leverandøren kreditere duplikatet',
  'avdp.drawer.followUpDeadline': 'Frist for oppfølging',
  'avdp.drawer.markFollowUp': 'Merk for oppfølging neste periode',
  'avdp.drawer.linkedDocOne': '{count} dokument er koblet til kontrollkontoen i denne perioden.',
  'avdp.drawer.linkedDocMany': '{count} dokumenter er koblet til kontrollkontoen i denne perioden.',
  'avdp.drawer.needsJustification': 'Denne vurderingen krever en begrunnelse.',
  'avdp.drawer.save': 'Lagre vurdering',
  'avdp.drawer.requestDocs': 'Be klienten om dokumentasjon',
});
